import { loadComponents, getComponent } from '../src/utils/custom-components-functions.js';
const routeComponents = loadComponents();

export const routesData = [
  {
    name: 'HomePage',
    path: '/',
    component: getComponent(routeComponents, 'HomePage')
  },
  {
    name: 'AppointmentsCalendarPage',
    path: '/appointments',
    roles: ['service-center'],
    store: 'appointmentsCalendarStore',
    component: getComponent(routeComponents, 'AppointmentsCalendarPage'),
    navigation: { group: 'covid-testing', icon: 'mdi-calendar-month', title: 'Appointments' },
    subRoutes: [
      {
        name: 'AppointmentsSelectedDayPage',
        path: '/appointments/:selectedDate',
        roles: ['service-center-admin'],
        component: getComponent(routeComponents, 'AppointmentsSelectedDayPage')
      }
    ]
  },
  {
    name: 'TestTubeLinkPage',
    path: '/test-tube-link/:caseId?',
    roles: ['service-center', 'service-center-scan'],
    store: 'testTubeLinkStore',
    component: getComponent(routeComponents, 'TestTubeLinkPage'),
    navigation: { group: 'covid-testing', icon: 'mdi-qrcode-scan', title: 'Test Tube Linking' },
    customComponents: {
      AppointmentsSelectedCase: true // expample
    }
  },
  {
    name: 'CreateCasePage',
    path: '/create-case',
    roles: ['service-center', 'service-center-scan'],
    component: getComponent(routeComponents, 'CreateCasePage'),
    navigation: { group: 'covid-testing', icon: 'mdi-account-plus', title: 'Create Case' }
  },
  {
    name: 'TestKitPage',
    path: '/testkit',
    roles: ['service-center', 'service-center-scan'],
    store: 'testKitStore',
    component: getComponent(routeComponents, 'TestKitPage'),
    navigation: { group: 'covid-testing', icon: 'mdi-tag-search', title: 'Test Kit' }
  },
  {
    name: 'DoctorCodesPage',
    path: '/doctor-codes',
    roles: ['service-center-admin', 'service-center-doctor-codes'],
    component: getComponent(routeComponents, 'DoctorCodesPage'),
    navigation: { group: 'config', order: 2, icon: 'mdi-doctor', title: 'Doctor Codes' }
  },
  {
    name: 'TestTypes',
    path: '/test-types',
    roles: ['service-center-testtypes', 'service-center-admin'],
    component: getComponent(routeComponents, 'TestTypes'),
    navigation: { group: 'config', icon: 'mdi-test-tube', title: 'Test Types' }
  },

];
